import { PERMISSIONS, type PermissionString } from './catalog';

/**
 * Who may open Intents (AGE-42) — any ONE of these atomic permissions.
 *
 * `agent.intents.view` is the dedicated permission. `agent.conversational_flows.view`
 * stays in the list ONLY for the rollout: until `seed-intents-view.ts` has run in an
 * environment, no role holds `agent.intents.view` there, and gating on it alone would
 * hide Intents from every non-superuser role — the regression QA flagged when the
 * frontend reached staging before the permission did (AGE-42, 2026-09-09).
 *
 * Remove `conversationalFlows.view` from this list once the seed has run in dev,
 * staging AND prod. After that, the two permissions are fully independent.
 */
export const INTENTS_ACCESS: readonly PermissionString[] = [
  PERMISSIONS.agent.intents.view,
  PERMISSIONS.agent.conversationalFlows.view,
];
